import { __read, __spreadArray } from "tslib";
import { find, memoize, uniqBy } from 'lodash-es';
import * as status from '../constants/contentStatus';
export function getImageBatch(_a) {
    var screen = _a.screen, screens = _a.screens, screenMap = _a.screenMap, depth = _a.depth;
    // each depth of screens stored as an array
    var queue = [[screen]];
    var batch = [];
    var iteration = 0;
    var _loop_1 = function () {
        var isLastScreen = depth - iteration <= 1;
        // don't want linked screens for images already in the batch
        var screensToGetLinkedScreensFor = queue[0].filter(function (_a) {
            var id = _a.id;
            return !find(batch, ['id', id]);
        });
        var linkedScreens = uniqBy(screensToGetLinkedScreensFor, 'id').reduce(function (queueAndBatch, currentScreen) {
            return getAllLinkedScreens({
                queueAndBatch: queueAndBatch,
                currentScreen: currentScreen,
                isLastScreen: isLastScreen,
                screens: screens,
                screenMap: screenMap,
            });
        }, {
            screensToQueue: [],
            screensToAddToBatch: [],
        });
        var screensToQueue = linkedScreens.screensToQueue, screensToAddToBatch = linkedScreens.screensToAddToBatch;
        if (screensToQueue.length)
            queue.push(screensToQueue);
        if (screensToAddToBatch.length)
            batch.push.apply(batch, __spreadArray([], __read(screensToAddToBatch), false));
        // done with current depth, remove
        queue.shift();
        iteration += 1;
    };
    while (queue.length && iteration < depth) {
        _loop_1();
    }
    return batch;
}
function getAllLinkedScreens(_a) {
    var _b = _a.queueAndBatch, screensToAddToBatch = _b.screensToAddToBatch, screensToQueue = _b.screensToQueue, currentScreen = _a.currentScreen, isLastScreen = _a.isLastScreen, screens = _a.screens, screenMap = _a.screenMap;
    var id = currentScreen.id, url = currentScreen.img.url, order = currentScreen.order, contentStatus = currentScreen.contentStatus;
    var i = order - 1;
    var addToBatchScreens = screensToAddToBatch;
    if (isLoadable(contentStatus)) {
        addToBatchScreens = __spreadArray(__spreadArray([], __read(screensToAddToBatch), false), [{ id: id, url: url }], false);
    }
    // no need to queue screens for last iteration
    if (!isLastScreen) {
        var queueScreens = getScreensToQueue({
            screens: screens,
            i: i,
            currentScreen: currentScreen,
            screenMap: screenMap,
        });
        return {
            screensToQueue: __spreadArray(__spreadArray([], __read(screensToQueue), false), __read(queueScreens), false),
            screensToAddToBatch: addToBatchScreens,
        };
    }
    return {
        screensToQueue: __spreadArray([], __read(screensToQueue), false),
        screensToAddToBatch: addToBatchScreens,
    };
}
function getScreensToQueue(_a) {
    var screens = _a.screens, i = _a.i, currentScreen = _a.currentScreen, screenMap = _a.screenMap;
    var nextScreen = getAdjacentScreen(screens, i, 'next');
    var prevScreen = getAdjacentScreen(screens, i);
    var linkedScreens = getHotspotLinkedScreens({
        currentScreen: currentScreen,
        screenMap: screenMap,
    });
    var screensToQueue = __spreadArray([nextScreen, prevScreen], __read(linkedScreens), false).filter(function (screen) { return isLoadable(screen.contentStatus); });
    return screensToQueue;
}
function getAdjacentScreen(screens, i, screenType) {
    var noOfScreens = screens.length;
    var screenIndex;
    if (screenType === 'next') {
        screenIndex = (i + 1) % noOfScreens;
    }
    else {
        screenIndex = (i - 1 + noOfScreens) % noOfScreens;
    }
    return screens[screenIndex];
}
function getHotspotLinkedScreens(_a) {
    var currentScreen = _a.currentScreen, screenMap = _a.screenMap;
    var linkedScreens = [];
    currentScreen.allHotspots.forEach(function (hotspot) {
        var id = hotspot.destinationScreenID;
        var screen = getScreenById(screenMap, id);
        linkedScreens.push(screen);
    });
    return linkedScreens;
}
function getScreenById(screenMap, id) {
    return screenMap[id];
}
function isLoadable(contentStatus) {
    return contentStatus === status.IMAGE_UPLOAD_DONE;
}
function cacheResolver(_a) {
    var screen = _a.screen, depth = _a.depth;
    return JSON.stringify({ id: screen.id, depth: depth });
}
var getImagesToPreload = memoize(getImageBatch, cacheResolver);
export default getImagesToPreload;
